import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function AuthWrapper({ children }) {
  const navigate = useNavigate();
  const { authenticated, user } = useSelector((state) => state.auth);
  const isAuthenticating = useSelector((state) => state.auth.authenticate.loading);

  useEffect(() => {
    // Wait for authentication check to complete
    if (isAuthenticating) {
      return;
    }

    // If not authenticated and no user data, redirect to login
    if (!authenticated && !user) {
      navigate("/login");
    }
  }, [authenticated, user, isAuthenticating, navigate]);

  // Show nothing while authenticating
  if (isAuthenticating) {
    return null;
  }

  return children;
}
